<template>
    <div>
        <div class="info-box" @click="hideShare" v-if="is_show_share"></div>
        <div class="info-to-wx" v-if="is_show_share">
            <img src="https://o-yzx.bysjy.com.cn/common/zhuanfa.png" class="info-arrows-icon">
            <p class="info-tit">立即分享给好友吧</p>
            <p class="info-tit">点击屏幕右上角<img src="https://o-yzx.bysjy.com.cn/common/dian.png">将本页面分享给好友</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "share",
        props:{
            is_show_share:Boolean
        },
        data(){
            return {
                show_share:false,
            }
        },
        methods:{
            hideShare(){
                this.show_share = false;

                this.$emit('hideShare', this.show_share);
            },
        }
    }
</script>

<style scoped>
    .info-box{
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0;
        background: rgba(0,0,0,0.7);
        z-index: 5;
    }
    .info-to-wx{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10;
        padding-top: 67px;
    }
    .info-to-wx .info-arrows-icon{
        position: absolute;
        right: 52px;
        top: 14px;
        width: 52px;
        height: 52px;
    }
    .info-to-wx .info-tit{
        line-height: 26px;
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        padding-bottom: 8px;
    }
</style>
